import { getGlobalConfig } from './globalConfig';

const {
  EMAIL_VALIDATOR_URL,
  PHONE_VALIDATOR_URL,
  AUTOLIST_API_URL,
  DEALER_PAGES_API_URL,
  COMPARISONS_API_URL,
  CONTENT_API_URL,
  LOOKUP_API_URL,
  GOOGLE_OAUTH_CLIENT_ID,
  COGNITO_IDENTITY_POOL_ID,
  NODE_ENV,
  GOOGLE_MAPS_API_KEY,
  REDIS_URL,
  AUTH_ENABLED,
  AUTH_TOKEN_GENERATOR_URL,
  HOST,
  DISABLE_EVENTS,
  DEBUG_EVENTS,
  EVENTS_KINESIS_STREAM_NAME,
  EVENTS_KINESIS_ENDPOINT,
  IMAGE_TAG,
  GOOGLE_ADWORDS_CONVERSION_ID_NEW,
  GOOGLE_ADWORDS_CONVERSION_ID_OLD,
} = getGlobalConfig();

export default {
  authEnabled: AUTH_ENABLED || true,
  authTokenGeneratorUrl: AUTH_TOKEN_GENERATOR_URL,
  host: HOST || 'www.autolist.com',
  emailValidatorUrl: EMAIL_VALIDATOR_URL,
  phoneValidatorUrl: PHONE_VALIDATOR_URL,
  coreApiUrl: AUTOLIST_API_URL,
  dealerPagesApiUrl:
    DEALER_PAGES_API_URL ||
    'https://yligh314xb.execute-api.us-east-1.amazonaws.com/production/api/dealer_pages',
  comparisonsApiUrl:
    COMPARISONS_API_URL ||
    'https://3hpkht5dzk.execute-api.us-east-1.amazonaws.com/production/api/comparisons',
  contentApiUrl: CONTENT_API_URL,
  lookupApiUrl: LOOKUP_API_URL || 'https://www.autolist.com/api/lookup',
  googleOAuthClientId: GOOGLE_OAUTH_CLIENT_ID,
  cognitioIdentityPoolId: COGNITO_IDENTITY_POOL_ID,
  eventsKinesisStreamName: EVENTS_KINESIS_STREAM_NAME,
  eventsKinesisEndpoint: EVENTS_KINESIS_ENDPOINT,
  imageTag: IMAGE_TAG,
  googleAdwordsConversionIdNew: GOOGLE_ADWORDS_CONVERSION_ID_NEW,
  googleAdwordsConversionIdOld: GOOGLE_ADWORDS_CONVERSION_ID_OLD,
  nodeEnv: NODE_ENV,
  disableEvents: DISABLE_EVENTS,
  debugEvents: DEBUG_EVENTS || false,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  redisUrl: REDIS_URL,
};
